import { ApiService } from '@services/api.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class DocumentService {
  constructor(private api: ApiService) {}

  /**
   * マニュアルをダウンロードする。
   * @returns マニュアル
   */
  downloadManual(): Observable<HttpResponse<Blob>> {
    return this.api.get('/manual/tracks/_download', {
      responseType: 'blob',
      observe: 'response',
    });
  }
}
